(function () {
  if (window.__fairwinCvrBoostersLoaded) return;

  window.__fairwinCvrBoostersLoaded = true;

  const colorTargets = ['Black', 'Coyote Brown', 'Grey'];
  const productCache = new Map();

  const money = (cents, currency = window.Shopify?.currency?.active || 'USD') => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency,
      }).format((Number(cents) || 0) / 100);
    } catch (error) {
      return `$${((Number(cents) || 0) / 100).toFixed(2)}`;
    }
  };

  const emitFunnelEvent = (eventName, payload = {}) => {
    const detail = {
      source: 'fairwin_theme',
      event: eventName,
      page_path: window.location.pathname,
      page_url: window.location.href,
      timestamp: new Date().toISOString(),
      ...payload,
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: eventName, ...detail });
    window.dispatchEvent(new CustomEvent(eventName, { detail }));
  };

  const getOption = (item, optionName) => {
    const match = item.options_with_values?.find((option) => option.name.toLowerCase() === optionName.toLowerCase());
    return match?.value || '';
  };

  const fetchCart = () =>
    fetch(`${window.routes?.cart_url || '/cart'}.js`, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    }).then((response) => response.json());

  const fetchProduct = (handle) => {
    if (productCache.has(handle)) return productCache.get(handle);

    const request = fetch(`/products/${handle}.js`, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    }).then((response) => response.json());

    productCache.set(handle, request);
    return request;
  };

  const variantOption = (variant, position) => variant[`option${position}`] || '';

  const getOptionPosition = (product, name) => {
    const index = product.options?.findIndex((option) => option.name.toLowerCase() === name.toLowerCase());
    return index >= 0 ? index + 1 : null;
  };

  const findMatchingVariants = (product, currentItem) => {
    const colorPosition = getOptionPosition(product, 'Color');
    const sizePosition = getOptionPosition(product, 'Size');
    const currentColor = getOption(currentItem, 'Color');
    const currentSize = getOption(currentItem, 'Size');

    if (!colorPosition || !sizePosition || !currentSize) return [];

    return colorTargets
      .map((color) => {
        const variant = product.variants.find(
          (candidate) =>
            candidate.available &&
            variantOption(candidate, colorPosition).toLowerCase() === color.toLowerCase() &&
            variantOption(candidate, sizePosition) === currentSize
        );

        return variant
          ? {
              color,
              id: variant.id,
              price: variant.price,
              image: variant.featured_image?.src || product.featured_image,
              size: currentSize,
            }
          : null;
      })
      .filter(Boolean);
  };

  const renderSecondBelt = (root, cart, product, currentItem) => {
    const variants = findMatchingVariants(product, currentItem);

    if (!variants.length) {
      root.hidden = true;
      return;
    }

    const currentSize = getOption(currentItem, 'Size');
    root.hidden = false;
    root.innerHTML = `
      <div class="fairwin-second-belt__header">
        <span>One-click bundle</span>
        <strong>Add a second belt in the same size</strong>
        <p>Your cart has 1 eligible belt. Choose Black, Coyote Brown, or Grey to unlock the 30% second-belt offer automatically.</p>
      </div>
      <div class="fairwin-second-belt__options">
        ${variants
          .map(
            (variant) => `
              <button type="button" class="fairwin-second-belt__option" data-fairwin-add-variant="${variant.id}">
                ${
                  variant.image
                    ? `<img src="${variant.image}" alt="${variant.color} FAIRWIN belt" loading="lazy" width="72" height="72">`
                    : '<span class="fairwin-second-belt__swatch" aria-hidden="true"></span>'
                }
                <span>
                  <strong>Add matching ${variant.color}</strong>
                  <small>${currentSize} &middot; ${money(variant.price, cart.currency)}</small>
                </span>
              </button>
            `
          )
          .join('')}
      </div>
      <p class="fairwin-second-belt__status" data-fairwin-second-belt-status></p>
    `;
  };

  const addVariant = async (variantId, button) => {
    const root = button.closest('[data-fairwin-second-belt]');
    const status = root?.querySelector('[data-fairwin-second-belt-status]');
    const cartDrawer = document.querySelector('cart-drawer');
    const formData = new FormData();

    button.disabled = true;
    button.classList.add('is-loading');
    if (status) status.textContent = 'Adding your matching belt...';

    formData.append('id', variantId);
    formData.append('quantity', '1');
    formData.append('sections', ['cart-drawer', 'cart-icon-bubble', 'main-cart-items', 'main-cart-footer'].join(','));
    formData.append('sections_url', window.location.pathname);

    const response = await fetch(window.routes?.cart_add_url || '/cart/add', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: formData,
    }).then((res) => res.json());

    if (response.status) throw new Error(response.description || 'Unable to add this belt.');

    emitFunnelEvent('fairwin_second_belt_added', { variant_id: variantId });

    if (cartDrawer && response.sections?.['cart-drawer']) {
      cartDrawer.renderContents(response);
    }

    if (window.location.pathname === '/cart') {
      window.location.reload();
      return;
    }

    if (status) status.textContent = 'Added. Your second-belt value is ready.';
    window.setTimeout(() => fetchCart().then(initSecondBelt).catch(() => {}), 500);
  };

  const initSecondBelt = async (existingCart) => {
    const roots = document.querySelectorAll('[data-fairwin-second-belt]');
    if (!roots.length) return;

    const cart = existingCart?.items ? existingCart : await fetchCart();
    const totalQuantity = cart.items.reduce((sum, item) => sum + item.quantity, 0);
    const currentItem = cart.items.find((item) => item.quantity === 1 && getOption(item, 'Color') && getOption(item, 'Size'));

    if (totalQuantity !== 1 || !currentItem?.handle) {
      roots.forEach((root) => (root.hidden = true));
      return;
    }

    const product = await fetchProduct(currentItem.handle);
    roots.forEach((root) => renderSecondBelt(root, cart, product, currentItem));
  };

  const recommendSize = (waist) => {
    if (!waist) return null;
    if (waist < 33) return { size: 'XS', range: '29"-33"', note: 'Best if your jeans waist is under 33 inches.' };
    if (waist <= 37) return { size: 'S', range: '33"-37"', note: 'This is the safest pick for most 33-37 inch waists.' };
    if (waist <= 43) return { size: 'M', range: '37"-43"', note: 'Choose M for 37-43 inch waists and everyday movement.' };
    if (waist <= 47) return { size: 'L', range: '43"-47"', note: 'Choose L if you need more room sitting, driving or working.' };
    return { size: 'XL', range: '47"-51"', note: 'Choose XL. If you are above 51 inches, contact us before ordering.' };
  };

  const renderSize = (root, waist) => {
    const result = root.querySelector('[data-fairwin-size-result]');
    const recommendation = recommendSize(Number(waist));

    if (!result) return;

    if (!recommendation) {
      result.textContent = 'Enter your jeans waist to see the safest size. If you are between sizes, choose the larger range.';
      return;
    }

    result.innerHTML = `Recommended: <strong>${recommendation.size} (${recommendation.range} Waist)</strong>. ${recommendation.note}`;
    emitFunnelEvent('fairwin_size_recommended', {
      waist: Number(waist),
      recommended_size: recommendation.size,
    });
  };

  const initSizeAssistants = () => {
    document.querySelectorAll('[data-fairwin-size-assistant]').forEach((root) => {
      const input = root.querySelector('[data-fairwin-waist-input]');
      if (!input) return;

      input.addEventListener('input', () => renderSize(root, input.value));
      root.querySelectorAll('[data-fairwin-waist-chip]').forEach((chip) => {
        chip.addEventListener('click', () => {
          input.value = chip.dataset.fairwinWaistChip;
          renderSize(root, input.value);
        });
      });
    });
  };

  const initFunnelTracking = () => {
    if (document.querySelector('product-info')) {
      emitFunnelEvent('fairwin_product_viewed', {
        product_id: document.querySelector('product-info')?.dataset.productId,
      });
    }

    if (window.location.pathname === '/cart') {
      fetchCart()
        .then((cart) => emitFunnelEvent('fairwin_cart_viewed', { item_count: cart.item_count, total_price: cart.total_price }))
        .catch(() => {});
    }

    document.addEventListener(
      'submit',
      (event) => {
        if (event.target.matches('form[action*="/cart/add"]')) {
          emitFunnelEvent('fairwin_product_added_to_cart_attempt');
        }
      },
      true
    );

    document.addEventListener(
      'click',
      (event) => {
        if (event.target.closest('button[name="checkout"], a[href="/checkout"], a[href*="/checkout"]')) {
          emitFunnelEvent('fairwin_checkout_started');
        }
      },
      true
    );

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        emitFunnelEvent('fairwin_product_added_to_cart', {
          source: event?.source,
          variant_id: event?.productVariantId || event?.cartData?.variant_id,
          item_count: event?.cartData?.item_count,
        });
        window.setTimeout(() => initSecondBelt().catch(() => {}), 400);
      });
    }
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-fairwin-add-variant]');
    if (!button) return;

    addVariant(button.dataset.fairwinAddVariant, button).catch((error) => {
      const root = button.closest('[data-fairwin-second-belt]');
      const status = root?.querySelector('[data-fairwin-second-belt-status]');
      button.disabled = false;
      button.classList.remove('is-loading');
      if (status) status.textContent = error.message || 'Unable to add this belt. Please try again.';
    });
  });

  initSizeAssistants();
  initSecondBelt().catch(() => {});
  initFunnelTracking();
})();
